import { css } from '@emotion/react';
import {
  faGripLines,
  faXmark,
} from '@fortawesome/pro-solid-svg-icons';
import {
  GroupButtonComponent, type GroupButtonItem,
  GroupButtonSize,
} from '~/_shared/baseComponents/buttons';
import { FontAwesomeIcon } from '~/_shared/baseComponents/icon/fontAwesomeIcon.component';
import type { Theme } from '~/_shared/themes/theme.model';
import type { MapPageSplitScreenTab } from './mapPageSplitScreen.types';

const gutterStyle = (theme: Theme) => css({
  background: theme.backgroundColors.quinary,
  position: 'relative',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  borderColor: theme.borderColors.primary,
  borderStyle: 'solid',
  borderWidth: '1px 0',
  display: 'flex',
  width: '100%',
});

const gutterLinesIconStyle = css({
  fontSize: '16px',
  fontWeight: 900,
});

const gutterCloseStyle = css({
  height: '100%',
  width: '40px',
  lineHeight: '100%',
  fontSize: '22px',
  fontWeight: 900,
  textAlign: 'center',
  background: 'none',
  color: 'inherit',
  border: 'none',
});

const gutterLeftSideStyle = css({
  position: 'absolute',
  top: 0,
  right: 0,
  height: '100%',
  display: 'flex',
  alignItems: 'center',
});

type MapPageSplitScreenGutterComponentProps = Readonly<{
  tabsItems: ReadonlyArray<GroupButtonItem<MapPageSplitScreenTab>>;
  selectedTab: MapPageSplitScreenTab;
  isMobileScreen: boolean;
  onClose: () => void;
}>;

export const MapPageSplitScreenGutterComponent = ({
  isMobileScreen,
  tabsItems,
  selectedTab,
  onClose,
}: MapPageSplitScreenGutterComponentProps) => {

  return (
    <div css={gutterStyle}>
      <FontAwesomeIcon
        css={gutterLinesIconStyle}
        icon={faGripLines}
      />

      {!isMobileScreen && (
        <div css={gutterLeftSideStyle}>
          <div>
            <GroupButtonComponent
              buttonItems={tabsItems}
              buttonSize={GroupButtonSize.M}
              selectedButtonItemId={selectedTab}
            />
          </div>
          <button
            css={gutterCloseStyle}
            onClick={onClose}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>
      )}
    </div>
  );
};
